//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const LOCAL_RELEASE = '0.1.0-SNAPSHOT';

/**
 * @description
 * This conditional is used to prevent local instances of the dashboard from running certain services.
 * The release check is best-effort, as we default the value to '0.1.0-SNAPSHOT' in our
 * webpack configurations and pom. This value is overridden during our
 * deploy/release jobs and does not ever need to be overridden during local
 * development. We also check navigator.webdriver which will be true if the browser is automated.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/webdriver
 */
export const isProdBuild = (
  release?: string,
  hostname?: string,
  isNavigatorWebdriver?: boolean,
): boolean => {
  return (
    !!release &&
    release !== LOCAL_RELEASE &&
    !hostname?.includes('local') &&
    !isNavigatorWebdriver
  );
};

/**
 * @description Used allow a service that would normally return not run in an automated environment with the isProdBuild check
 * Set ignoreAutomatedBrowser to true if a service should init in an automated browser environment with same params as isProdBuild
 * @param release
 * @param hostname
 * @param isNavigatorWebdriver
 * @param ignoreAutomatedBrowser
 * @returns
 */
export const shouldInitWithAutomatedBrowser = (
  release: string,
  hostname: string,
  isNavigatorWebdriver?: boolean,
  ignoreAutomatedBrowser?: boolean,
): boolean => {
  const isLocalRelease = !isProdBuild(release, hostname);

  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/webdriver

  const isAutomatedBrowser = !!(
    !ignoreAutomatedBrowser && isNavigatorWebdriver
  );

  return !(isLocalRelease || isAutomatedBrowser);
};
